export default __webpack_public_path__ + "static/media/card-14.26965b23.png";